import React from 'react';
import { services } from '../../data/mock';
import { Flower2, PartyPopper, MessageSquare, ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';

const iconMap = {
  0: Flower2,
  1: PartyPopper,
  2: MessageSquare,
};

const ServicesSection = () => {
  const handleScroll = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="szolgaltatasok" className="py-24 bg-soft-gray">
      <div className="container mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="font-montserrat text-sm uppercase tracking-[0.2em] text-warm-sage mb-4">
            Amit kínálunk
          </p>
          <h2 className="font-playfair text-3xl md:text-4xl text-charcoal">
            Szolgáltatásaink
          </h2>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const IconComponent = iconMap[index];
            return (
              <div
                key={service.id}
                className="group bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-lg transition-all duration-300"
              >
                {/* Card Header */}
                <div className="p-8 pb-6">
                  <div className="flex items-center gap-4 mb-4">
                    <div className="w-12 h-12 rounded-full bg-warm-sage/10 flex items-center justify-center">
                      <IconComponent className="w-6 h-6 text-warm-sage" />
                    </div>
                    <h3 className="font-playfair text-xl text-charcoal">
                      {service.title}
                    </h3>
                  </div>
                  <p className="font-montserrat text-sm text-warm-gray leading-relaxed">
                    {service.description}
                  </p>
                </div>

                {/* Features List */}
                <div className="px-8 pb-8">
                  <ul className="space-y-2">
                    {service.features.map((feature, idx) => (
                      <li
                        key={idx}
                        className="font-montserrat text-sm text-charcoal flex items-center gap-2"
                      >
                        <span className="w-1.5 h-1.5 rounded-full bg-warm-sage" />
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Card Footer */}
                <div className="px-8 pb-8">
                  <Button
                    variant="ghost"
                    onClick={(e) => handleScroll(e, '#kapcsolat')}
                    className="text-warm-sage hover:text-warm-sage/80 font-montserrat text-sm uppercase tracking-wider p-0 h-auto group/btn"
                  >
                    Érdeklődöm
                    <ArrowRight className="w-4 h-4 ml-2 transition-transform group-hover/btn:translate-x-1" />
                  </Button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
